// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/css/banner.css
// module id = 657
// module chunks = 177